import { useEffect, useState } from 'react';
import { apiUrl } from '../../api/apiUrl';
import http from '../../api/axios';
import DataTable from '../../components/table/DataTable';
import { columns } from '../../components/columns/Company/TeamMembersColumns';
import { TeamMember } from '../../types/TeamMember';
import { useNavigate, useParams } from 'react-router-dom';
import { paths } from '../../pages/RouterContainer';

interface Props {
  teamId: number;
  membershipId?: number;
  isReadOnly?: boolean;
}
/**
 * Component to assign and edit users of team
 */
export const TeamMemberAssign = ({ teamId, membershipId, isReadOnly }: Props) => {
  const { companyId } = useParams();
  const navigate = useNavigate();
  // Users assigned to team
  const [teamMembers, seTeamMembers] = useState<TeamMember[] | null>(null);
  const isCurrent = window.location.pathname.includes(`current`);
  /**
   * Loads users teams. Ready to assing to company.
   */
  const fetchTeamMembers = async () => {
    const response = await http.apiGet({ url: `${apiUrl.TEAM_MEMBER_LIST}?parentId=${teamId}` });
    seTeamMembers(response?.data);
  };

  useEffect(() => {
    if (!teamId) return;
    fetchTeamMembers();
  }, [teamId]);

  /**
   * Redirects to company team member edit page
   * @param id
   */
  const onEditTeamMember = (id: string | number) => {
    if (teamId === null) return;
    const _membershipId = teamMembers?.find((member: TeamMember) => member.id === id)?.id;
    navigate(
      `/${paths.COMPANY_TEAMS}/${isCurrent ? `current` : companyId}/edit/${membershipId}/${
        paths.MEMBERS
      }/edit/${_membershipId}`,
    );
  };

  return (
    <DataTable
      data={teamMembers}
      columns={columns}
      handleEdit={isReadOnly ? undefined : onEditTeamMember}
    />
  );
};
